import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class NewTeamService {

    constructor(
        private http: HttpClient
    ) { }

    createTeam(teamObj) {
        return this.http.post(environment.serverUrl + '/team', teamObj);
    }

    updateTeam(teamObj) {
        return this.http.put(environment.serverUrl + '/team', teamObj);
    }

    getAuthTypes() {
        return this.http.get(environment.serverUrl + '/authType');
    }

    getRoles(){
        return this.http.get(environment.serverUrl + '/capabilities')
    }
}



// WEBPACK FOOTER //
// ./src/app/new-team/new-team.service.ts